import type {TextureFromSetSockets} from "#material/nodes/texture/texture-from-set/definition"
import type {SettingValueOfType} from "#material/sockets/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<TextureFromSetSockets>
type Previous = Omit<Current, "settings"> & {settings: MaterialNodeSettings<TextureFromSetSockets> & {color?: SettingValueOfType<"color">}}

/** The node's colour is its output, never a setting, and the colormass group has no socket to carry one. */
export const dropColorNoRendererReads: Version<Previous, Current> = {
    toNextVersion: ({settings: {color, ...settings} = {}, ...parameters}) => ({...parameters, settings}),
}
